import Youtube from "../../../../../../public/image/generator/logos/youTubeLogotype.svg";
import Instagram from "../../../../../../public/image/generator/logos/instagramLogotype.svg";
import Facebook from "../../../../../../public/image/generator/logos/faceBookLogotype.svg";
import Whatsapp from "../../../../../../public/image/generator/logos/whatsAppLogotype.svg";
import Linkedin from "../../../../../../public/image/generator/logos/linkedInLogotype.svg";
import Telegram from "../../../../../../public/image/generator/logos/telegramLogotype.svg";
import Twitter from "../../../../../../public/image/generator/logos/twitterLogotype.svg";
import Messenger from "../../../../../../public/image/generator/logos/messengerLogotype.svg";
import Tiktok from "../../../../../../public/image/generator/logos/tiktokLogotype.svg";
import Snapchat from "../../../../../../public/image/generator/logos/snapchatLogotype.svg";
import Skype from "../../../../../../public/image/generator/logos/skypeLogotype.svg";
import Spotify from "../../../../../../public/image/generator/logos/spotifyLogotype.svg";
import Pinterest from "../../../../../../public/image/generator/logos/pinterestLogotype.svg";
import Dribbble from "../../../../../../public/image/generator/logos/dribbbleLogotype.svg";
import Behance from "../../../../../../public/image/generator/logos/behanceLogotype.svg";
import Google from "../../../../../../public/image/generator/logos/googleLogotype.svg";
import Twitch from "../../../../../../public/image/generator/logos/twitchLogotype.svg";
import Xbox from "../../../../../../public/image/generator/logos/xboxLogotype.svg";
import Dropbox from "../../../../../../public/image/generator/logos/dropboxLogotype.svg";
import Reddit from "../../../../../../public/image/generator/logos/redditLogotype.svg";
import Vimeo from "../../../../../../public/image/generator/logos/vimeoLogotype.svg";
import Github from "../../../../../../public/image/generator/logos/githubLogotype.svg";
import Apple from "../../../../../../public/image/generator/logos/appleLogotype.svg";
import Slack from "../../../../../../public/image/generator/logos/slackLogotype.svg";
import UberEats from "../../../../../../public/image/generator/logos/uberEatsLogotype.svg";
import Airbnb from "../../../../../../public/image/generator/logos/airbnbLogotype.svg";
import Android from "../../../../../../public/image/generator/logos/androidLogotype.svg";
import Band from "../../../../../../public/image/generator/logos/bandLogotype.svg";
import Binance from "../../../../../../public/image/generator/logos/binanceLogotype.svg";
import BoltFood from "../../../../../../public/image/generator/logos/boltFoodLogotype.svg";
import Booking from "../../../../../../public/image/generator/logos/bookingLogotype.svg";
import ChatGpt from "../../../../../../public/image/generator/logos/chatGptLogotype.svg";
import Discord from "../../../../../../public/image/generator/logos/discordLogotype.svg";
import Glovo from "../../../../../../public/image/generator/logos/glovoLogotype.svg";
import GoogleDrive from "../../../../../../public/image/generator/logos/googleDriveLogotype.svg";
import GoogleMaps from "../../../../../../public/image/generator/logos/googleMapsLogotype.svg";
import GooglePlay from "../../../../../../public/image/generator/logos/googlePlayLogotype.svg";
import Josh from "../../../../../../public/image/generator/logos/joshLogotype.svg";
import KakaoTalk from "../../../../../../public/image/generator/logos/kakaoTalkLogotype.svg";
import Kutumb from "../../../../../../public/image/generator/logos/kutumbLogotype.svg";
import Line from "../../../../../../public/image/generator/logos/lineLogotype.svg";
import Mailchimp from "../../../../../../public/image/generator/logos/mailchimpLogotype.svg";
import Meta from "../../../../../../public/image/generator/logos/metaLogotype.svg";
import Moj from "../../../../../../public/image/generator/logos/mojLogotype.svg";
import Naver from "../../../../../../public/image/generator/logos/naverLogotype.svg";
import Payoneer from "../../../../../../public/image/generator/logos/payoneerLogotype.svg";
import PayPal from "../../../../../../public/image/generator/logos/payPalLogotype.svg";
import Playstation from "../../../../../../public/image/generator/logos/playstationLogotype.svg";
import Public from "../../../../../../public/image/generator/logos/publicLogotype.svg";
import Qzone from "../../../../../../public/image/generator/logos/qzoneLogotype.svg";
import ShareChat from "../../../../../../public/image/generator/logos/shareChatLogotype.svg";
import Snow from "../../../../../../public/image/generator/logos/snowLogotype.svg";
import Stripe from "../../../../../../public/image/generator/logos/stripeLogotype.svg";
import Tencent from "../../../../../../public/image/generator/logos/tencentLogotype.svg";
import Threads from "../../../../../../public/image/generator/logos/threadsLogotype.svg";
import Tripadvisor from "../../../../../../public/image/generator/logos/tripadvisorLogotype.svg";
import Trustpilot from "../../../../../../public/image/generator/logos/trustpilotLogotype.svg";
import Viber from "../../../../../../public/image/generator/logos/viberLogotype.svg";
import WeChat from "../../../../../../public/image/generator/logos/weChatLogotype.svg";
import Weibo from "../../../../../../public/image/generator/logos/weiboLogotype.svg";
import Youku from "../../../../../../public/image/generator/logos/youkuLogotype.svg";
import ZoomMeet from "../../../../../../public/image/generator/logos/zoomLogotype.svg";
import gMail from "../../../../../../public/image/generator/logos/gMailLogotype.svg";
import PiNetwork from "../../../../../../public/image/generator/logos/piNetworkLogotype.svg";
import ScanMe1 from "../../../../../../public/image/generator/logos/scanMe1Logotype.svg";
import ScanMe2 from "../../../../../../public/image/generator/logos/scanMe2Logotype.svg";
import ScanMe3 from "../../../../../../public/image/generator/logos/scanMe3Logotype.svg";
import ScanMe4 from "../../../../../../public/image/generator/logos/scanMe4Logotype.svg";
import ScanMe5 from "../../../../../../public/image/generator/logos/scanMe5Logotype.svg";
import ScanMe6 from "../../../../../../public/image/generator/logos/scanMe6Logotype.svg";

export const logoCategories = [
  "social",
  "travel",
  "shopping",
  "jobs",
  "beauty",
];

export const defaultLogo = [
  { id: "youTubeLogotype", img: Youtube, category: logoCategories[0] },
  { id: "faceBookLogotype", img: Facebook, category: logoCategories[0] },
  { id: "whatsAppLogotype", img: Whatsapp, category: logoCategories[0] },
  { id: "instagramLogotype", img: Instagram, category: logoCategories[0] },
  { id: "linkedInLogotype", img: Linkedin, category: logoCategories[0] },
  { id: "telegramLogotype", img: Telegram, category: logoCategories[0] },
  { id: "twitterLogotype", img: Twitter, category: logoCategories[0] },
  { id: "messengerLogotype", img: Messenger, category: logoCategories[0] },
  { id: "tiktokLogotype", img: Tiktok, category: logoCategories[0] },
  { id: "snapchatLogotype", img: Snapchat, category: logoCategories[0] },
  { id: "skypeLogotype", img: Skype, category: logoCategories[0] },
  { id: "spotifyLogotype", img: Spotify, category: logoCategories[0] },
  { id: "pinterestLogotype", img: Pinterest, category: logoCategories[0] },
  { id: "dribbbleLogotype", img: Dribbble, category: logoCategories[0] },
  { id: "behanceLogotype", img: Behance, category: logoCategories[0] },
  { id: "googleLogotype", img: Google, category: logoCategories[0] },
  { id: "twitchLogotype", img: Twitch, category: logoCategories[0] },
  { id: "slackLogotype", img: Slack, category: logoCategories[0] },
  { id: "xboxLogotype", img: Xbox, category: logoCategories[0] },
  { id: "dropboxLogotype", img: Dropbox, category: logoCategories[0] },
  { id: "redditLogotype", img: Reddit, category: logoCategories[0] },
  { id: "vimeoLogotype", img: Vimeo, category: logoCategories[0] },
  { id: "githubLogotype", img: Github, category: logoCategories[0] },
  { id: "appleLogotype", img: Apple, category: logoCategories[0] },
  { id: "weChatLogotype", img: WeChat, category: logoCategories[0] },
  { id: "metaLogotype", img: Meta, category: logoCategories[0] },
  { id: "threadsLogotype", img: Threads, category: logoCategories[0] },
  { id: "trustpilotLogotype", img: Trustpilot, category: logoCategories[0] },
  { id: "lineLogotype", img: Line, category: logoCategories[0] },
  { id: "viberLogotype", img: Viber, category: logoCategories[0] },
  { id: "androidLogotype", img: Android, category: logoCategories[0] },
  { id: "playstationLogotype", img: Playstation, category: logoCategories[0] },
  { id: "weiboLogotype", img: Weibo, category: logoCategories[0] },
  { id: "snowLogotype", img: Snow, category: logoCategories[0] },
  { id: "tencentLogotype", img: Tencent, category: logoCategories[0] },
  { id: "kakaoTalkLogotype", img: KakaoTalk, category: logoCategories[0] },
  { id: "youkuLogotype", img: Youku, category: logoCategories[0] },
  { id: "naverLogotype", img: Naver, category: logoCategories[0] },
  { id: "qzoneLogotype", img: Qzone, category: logoCategories[0] },
  { id: "publicLogotype", img: Public, category: logoCategories[0] },
  { id: "mojLogotype", img: Moj, category: logoCategories[0] },
  { id: "joshLogotype", img: Josh, category: logoCategories[0] },
  { id: "shareChatLogotype", img: ShareChat, category: logoCategories[0] },
  { id: "kutumbLogotype", img: Kutumb, category: logoCategories[0] },
  { id: "piNetworkLogotype", img: PiNetwork, category: logoCategories[0] },
  { id: "uberEatsLogotype", img: UberEats, category: logoCategories[0] },
  { id: "glovoLogotype", img: Glovo, category: logoCategories[0] },
  { id: "boltFoodLogotype", img: BoltFood, category: logoCategories[0] },
  { id: "googleDriveLogotype", img: GoogleDrive, category: logoCategories[0] },
  { id: "googleMapsLogotype", img: GoogleMaps, category: logoCategories[0] },
  { id: "googlePlayLogotype", img: GooglePlay, category: logoCategories[0] },
  { id: "gMailLogotype", img: gMail, category: logoCategories[0] },
  { id: "zoomLogotype", img: ZoomMeet, category: logoCategories[0] },
  { id: "chatGptLogotype", img: ChatGpt, category: logoCategories[0] },
  { id: "mailchimpLogotype", img: Mailchimp, category: logoCategories[0] },
  { id: "bookingLogotype", img: Booking, category: logoCategories[0] },
  { id: "airbnbLogotype", img: Airbnb, category: logoCategories[0] },
  { id: "tripadvisorLogotype", img: Tripadvisor, category: logoCategories[0] },
  { id: "payPalLogotype", img: PayPal, category: logoCategories[0] },
  { id: "payoneerLogotype", img: Payoneer, category: logoCategories[0] },
  { id: "stripeLogotype", img: Stripe, category: logoCategories[0] },
  { id: "binanceLogotype", img: Binance, category: logoCategories[0] },
  { id: "bandLogotype", img: Band, category: logoCategories[0] },
  { id: "discordLogotype", img: Discord, category: logoCategories[0] },
  { id: "scanMe1Logotype", img: ScanMe1, category: logoCategories[0] },
  { id: "scanMe2Logotype", img: ScanMe2, category: logoCategories[0] },
  { id: "scanMe3Logotype", img: ScanMe3, category: logoCategories[0] },
  { id: "scanMe4Logotype", img: ScanMe4, category: logoCategories[0] },
  { id: "scanMe5Logotype", img: ScanMe5, category: logoCategories[0] },
  { id: "scanMe6Logotype", img: ScanMe6, category: logoCategories[0] },
];
